import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HomeComponent } from './screens/home/home.component';
import { ShowcaseComponent } from './screens/home/showcase/showcase.component';
import { CoursesComponent } from './screens/home/courses/courses.component';
import { HeaderComponent } from './screens/header/header.component';
import { FooterComponent } from './screens/footer/footer.component';
import { TestimonialsComponent } from './screens/home/testimonials/testimonials.component';
import { NewsComponent } from './screens/home/news/news.component';
import { AboutUsComponent } from './screens/home/about-us/about-us.component';
import { VacancyComponent } from './screens/home/vacancy/vacancy.component';
import { FacilitiesComponent } from './screens/home/facilities/facilities.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { AnnouncementsComponent } from './screens/home/announcements/announcements.component';
import { WhyChooseUsComponent } from './screens/home/why-choose-us/why-choose-us.component';
import { FormsComponent } from './screens/forms/forms.component';



@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    ShowcaseComponent,
    CoursesComponent,
    HeaderComponent,
    FooterComponent,
    TestimonialsComponent,
    NewsComponent,
    AboutUsComponent,
    VacancyComponent,
    FacilitiesComponent,
    AnnouncementsComponent,
    WhyChooseUsComponent,



  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    // AngularFireDatabaseModule,
    CarouselModule,
    PdfViewerModule,

    FormsModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
